// Funções puras para formatar CPF e CNPJ (sem React)
export const onlyDigits = (v?: string | null) => (v ?? "").replace(/\D/g, "");

/**
 * Limite de nome de empresa nas listagens. Nome longo empurrava a coluna de
 * ações e fazia os ícones quebrarem linha.
 */
export const COMPANY_NAME_MAX_LENGTH = 20;

/** Corta o texto e marca o corte com reticências. */
export const truncateText = (
  value: string,
  max = COMPANY_NAME_MAX_LENGTH
): string => (value.length > max ? `${value.slice(0, max)}...` : value);

export const formatCPF = (v?: string | null): string => {
  const digits = onlyDigits(v).slice(0, 11);
  if (!digits) return "";
  return digits.replace(
    /^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2}).*$/,
    (_m, g1, g2, g3, g4) =>
      (g1 || "") +
      (g2 ? `.${g2}` : "") +
      (g3 ? `.${g3}` : "") +
      (g4 ? `-${g4}` : "")
  );
};

export const formatPhone = (v?: string | null): string => {
  const digits = onlyDigits(v);
  if (!digits) return "";

  // 11 dígitos: celular com DDD -> (XX) XXXXX-XXXX
  if (digits.length === 11) {
    return digits.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
  }
  // 10 dígitos: fixo com DDD -> (XX) XXXX-XXXX
  if (digits.length === 10) {
    return digits.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
  }
  // 9 dígitos: celular sem DDD -> XXXXX-XXXX
  if (digits.length === 9) {
    return digits.replace(/^(\d{5})(\d{4})$/, "$1-$2");
  }
  // 8 dígitos: fixo sem DDD -> XXXX-XXXX
  if (digits.length === 8) {
    return digits.replace(/^(\d{4})(\d{4})$/, "$1-$2");
  }
  // formato desconhecido: devolve como veio
  return v ?? "";
};

export const formatCNPJ = (v?: string | null): string => {
  const digits = onlyDigits(v).slice(0, 14);
  if (!digits) return "";
  return digits.replace(
    /^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2}).*$/,
    (_m, g1, g2, g3, g4, g5) =>
      (g1 || "") +
      (g2 ? `.${g2}` : "") +
      (g3 ? `.${g3}` : "") +
      (g4 ? `/${g4}` : "") +
      (g5 ? `-${g5}` : "")
  );
};
